module.exports = __webpack_public_path__ + "img/service-and-shop-filter-nissan.7df99c3d.jpg";